import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';

@Component({
    selector: 'investment-decrease',
    templateUrl: './investment-decrease.component.html',
    styleUrls: ['./investment-decrease.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class InvestmentDecreaseComponent implements OnInit {
  @Input() derrors = false;
  options1: FormControlOption[] = [
    {
      value: true,
      label: 'Oui',
      suffix: { title: 'A' },
    },
    {
      value: false,
      label: 'Non',
      suffix: { title: 'B' },
    },
  ];
  options2: FormControlOption[] = [
    {
      value: 'INVEST',
      label:
        'Vous investissez de nouveau pour profiter des opportunités de marché',
      suffix: { title: 'A' },
    },
    {
      value: 'SELL_TOTALLY',
      label:
        'Vous vendez tout pour éventuellement réinvestir dans des supports moins risqués',
      suffix: { title: 'B' },
    },
    {
      value: 'SELL_PARTIALLY',
      label:
        'Vous vendez seulement une partie pour éventuellement réinvestir sur des supports moins risqués',
      suffix: { title: 'C' },
    },
    {
      value: 'NONE',
      label: 'Vous ne changez rien',
      suffix: { title: 'D' },
    },
  ];

  constructor(private controlContainer: FormGroupDirective) {}
  get form() {
    return this.controlContainer.form?.controls?.riskProfil;
  }

  ngOnInit() {}
}
